import {
  EXCLUDED_PERSONALIZATION_OBJECT_KEYS,
  EXCLUDED_PERSONALIZATION_SECTIONS,
  MESSAGE_KEY_PATTERN,
} from './constants';

const isPersonalizableMessageKey = (value) => typeof value === 'string' && MESSAGE_KEY_PATTERN.test(value);

const walkSection = (value, sectionName, sectionsByName, seenKeys) => {
  if (Array.isArray(value)) {
    value.forEach((item) => {
      walkSection(item, sectionName, sectionsByName, seenKeys);
    });
    return;
  }

  if (value && typeof value === 'object') {
    Object.entries(value).forEach(([key, item]) => {
      if (EXCLUDED_PERSONALIZATION_OBJECT_KEYS.has(key)) {
        return;
      }
      walkSection(item, sectionName, sectionsByName, seenKeys);
    });
    return;
  }

  if (!isPersonalizableMessageKey(value) || seenKeys.has(value)) {
    return;
  }

  seenKeys.add(value);

  if (!sectionsByName.has(sectionName)) {
    sectionsByName.set(sectionName, []);
  }

  sectionsByName.get(sectionName).push(value);
};

export function buildPersonalizationSections(productConfig) {
  if (!productConfig || typeof productConfig !== 'object') {
    return [];
  }

  const sectionsByName = new Map();
  const seenKeys = new Set();

  Object.entries(productConfig).forEach(([sectionName, sectionValue]) => {
    if (EXCLUDED_PERSONALIZATION_SECTIONS.has(sectionName)) {
      return;
    }
    walkSection(sectionValue, sectionName, sectionsByName, seenKeys);
  });

  return [...sectionsByName.entries()].map(([section, keys]) => ({
    section,
    keys,
  }));
}
